import {SeoError} from './SeoError.js'

export class SeoMakeModelFaqsError extends SeoError {}
